import { ApiSuccess, IApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { IUserTokenData, UserTokenData } from "./userTokenData";

export interface IUserPasswordEmailResult extends IApiSuccess {
    tokenData: IUserTokenData;
}

export class UserPasswordEmailResult extends ApiSuccess implements IUserPasswordEmailResult {
    tokenData: UserTokenData;

    constructor();
    constructor(obj: IUserPasswordEmailResult);
    constructor(obj?: any) {
        super(obj);
        this.tokenData = new UserTokenData(obj?.tokenData);
    }
}